<style scoped>
.absolute {
  position: absolute;
}
</style>

<template lang="pug">
    .row(v-if='productCodes.length')
      .col.l2.absolute(ref='drinkFilterContainer')
        app-drink-filter#drink-filter.hide-on-med-and-down(
          ref='drinkFilter',
          :categories='categories',
          :activeCategory='activeCategory',
          :searchKey='searchKey',
          @onSearchKeyword='onSearch',
          @onFilterCategory='filterCategory')

      .col.s12.l9.offset-l3
        .hide-on-large-only#filter-container.primary-background
          .vspace.small
          a.btn.btn-flat(@click='showFilter')
            i.material-icons.left filter_list
            | filters
        .row
          .row
            p.subtitle.light.col.s12(v-if='$route.query.name') Showing search results for "{{$route.query.name}}"
        .row(v-for='category in categories', :id='category')
          .row
            p.col.s12.title.small.text-capitalize.category {{category}}
          .row
            app-product-card(v-for='(drink, index) in products[category]', :key='drink.variant.id', :product='drink', :index='index', :path='drink.productCode + "?v=" + drink.variant.variantCode')
            p.col.s12.subtitle.medium.text-mute(v-if='!products[category] || products[category].length === 0') No drinks available
          .divider
    .row(v-else)
      .col.s12
        .vspace.large
        p.subtitle.large.center-align Nothing to see here yet
</template>
<script>
import AppDrinkFilter from '@/components/app-drink-filter'
import AppProductCard from '@/components/app-product-card'
import AppDrinkDetails from '@/components/app-drink-details'
import ScrollMonitor from 'scrollmonitor'
export default {
  props: ['shop'],
  data () {
    return {
      products: {},
      categories: [],
      activeCategory: null,
      searchKey: null,
      filterFixed: false,
      filterTop: null,
      initialY: 0,
      breakpoints: [],
      filterWatcher: null
    }
  },
  created () {
    this.searchKey = this.$route.query.name
    this.getCategories()
    this.updateModal()
  },
  mounted () {
    if (!this.$refs.drinkFilterContainer) {
      return
    }

    this.initialY = this.$refs.drinkFilterContainer.getBoundingClientRect().top
    window.onscroll = this.onScroll

    this.filterWatcher = ScrollMonitor.create(this.$refs.drinkFilterContainer, 130)
    this.filterWatcher.stateChange(() => {
      if (this.filterWatcher.isAboveViewport) {
        this.$refs.drinkFilterContainer.style.position = 'fixed'
        this.$refs.drinkFilterContainer.style.top = '130px'
      } else {
        this.$refs.drinkFilterContainer.style.position = 'absolute'
        this.$refs.drinkFilterContainer.style.top = 'inherit'
      }
    })
  },
  destroyed () {
    window.onscroll = null
    if (this.filterWatcher) {
      this.filterWatcher.destroy()
    }
  },
  computed: {
    productCodes () {
      return Object.keys(this.products)
    }
  },
  watch: {
    shop () {
      this.getCategories()
    },
    '$route.params' () {
      this.updateModal()
    },
    '$route.query' () {
      this.getDrinks()
    }
  },
  methods: {
    showFilter () {
      const modalParams = {
        content: AppDrinkFilter,
        style: { fullscreen: true, padding: 'medium' },
        bind: {
          onFilterCategory: this.filterCategory,
          onSearchKeyword: this.onSearch,
          categories: this.categories,
          activeCategory: this.activeCategory,
          searchKey: this.searchKey
        }
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    onAdded () {
      this.$store.dispatch('modal/close')
    },
    updateModal () {
      if (this.$route.params.productCode) {
        const product = {
          shopCode: this.$route.params.shopCode,
          productCode: this.$route.params.productCode
        }

        const modalParams = {
          content: AppDrinkDetails,
          bind: { viewProduct: product, onAddedHandler: this.onAdded },
          style: { padding: 'none' },
          onClose: this.close
        }

        this.$store.dispatch('modal/open', modalParams)
      } else {
        this.$store.dispatch('modal/close')
      }
    },
    close () {
      this.$router.back()
    },
    onScroll (e) {
      // if (window.scrollY + 128 >= this.initialY) {
      //   this.$refs.drinkFilterContainer.style.top = window.scrollY + 128 + 'px'
      // } else {
      //   this.$refs.drinkFilterContainer.style.top = this.initialY + 'px'
      // }

      this.categories.forEach(category => {
        const element = document.getElementById(category)
        if (element.getBoundingClientRect().top <= 128) {
          this.activeCategory = category
        }
      })
    },
    getCategories () {
      if (!this.shop || !this.shop.id) {
        return
      }

      return this.$http
        .get(`${this.$config.API_URL}/products/categories`, {
          params: {
            shopId: this.shop.id
          }
        })
        .then(result => {
          this.categories = result.data.map(category => category.name)
          return this.getDrinks()
        })
    },
    getDrinks () {
      this.products = {}
      const getProducts = this.categories.map(category => {
        const params = {
          ...this.$route.query,
          category: category,
          shopId: this.shop.id
        }

        return this.$http
          .get(`${this.$config.API_URL}/products`, {
            params: params
          })
          .then(products => {
            this.$set(this.products, category, products.data)
          })
      })
      return Promise.all(getProducts)
    },
    filterCategory (category) {
      this.activeCategory = category
      const element = document.getElementById(category)
      if (element) {
        const rect = element.getBoundingClientRect()
        window.scrollTo(0, window.scrollY - 128 + rect.top)
      }

      this.$store.dispatch('modal/close')
    },
    onSearch (searchKey) {
      let query = {
        ...this.$route.query,
        name: searchKey
      }

      if (!searchKey) {
        delete query['name']
      }

      this.$router.push({ path: this.$route.path, query: query })
    }
  },
  components: {
    AppDrinkFilter,
    AppProductCard
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page-supplier-drinks.vue